import React, { useState, useEffect, useRef } from 'react'
import RichText from '/react4xp/components/RichText'

interface Props {
   title: string,
   intro: string,
   faq: {
      question: string,
      answer: string,
   }[],
}

const chevron = (
   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.5 9L12 16.5L4.5 9" stroke="#002855" strokeWidth="2" strokeLinecap="square" />
   </svg>
)

export default function FAQ(props: Props) {
   const { title, intro, faq } = props
   const [openIndex, setOpenIndex] = useState<number | null>(null)
   const contentRefs = useRef<(HTMLDivElement | null)[]>([])
   const [currentContentHeight, setCurrentContentHeight] = useState<number>(0)

   const toggleAccordion = (index: number) => {
      setOpenIndex(openIndex === index ? null : index)
   }

   const updateContentHeight = () => {
      if (openIndex !== null) {
         const contentHeight = contentRefs.current[openIndex]?.getBoundingClientRect().height || 0
         setCurrentContentHeight(contentHeight)
      }
   }

   const handleResize = () => {
      updateContentHeight()
   }

   useEffect(() => {
      if (openIndex !== null) {
         updateContentHeight()
      }
   }, [openIndex])

   useEffect(() => {
      window.addEventListener('resize', handleResize)
      return () => {
         window.removeEventListener('resize', handleResize)
      }
   }, [openIndex])

   return (
      <div className="faq">
         <div className="grid-container">
            <div className="grid-row faq__wrapper">
               <div className="c-sm-4">
                  <div className="faq__aside">
                     {title && <div className="title font-title">{title}</div>}
                     {intro && <div className="intro"><RichText content={intro} /></div>}
                  </div>
               </div>
               <div className="c-sm-8">
                  <div className="faq__accordion">
                     {faq.map((item, index) => (
                        <div
                           className={`faq__item ${openIndex === index ? 'faq__item--open' : ''}`}
                           key={index}
                        >

                           <button onClick={() => toggleAccordion(index)}>
                              {item.question || 'Question'} <span className="icon">{chevron}</span>
                           </button>

                           <div
                              className="wrapper"
                              style={{
                                 maxHeight: index === openIndex ? `${currentContentHeight}px` : '0px'
                              }}
                           >
                              <div ref={(el) => { contentRefs.current[index] = el }} className="content">
                                 {item.answer && <RichText content={item.answer} />}
                              </div>
                           </div>
                        </div>
                     ))}
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}
